import {
  getObject,
  getOptionalObject,
} from "@surya-digital/leo-ts-types";
import { Code, CodeDTO } from "../types/code";
import { SurveyLocalizedText, SurveyLocalizedTextDTO } from "../assets/surveyLocalizedText";

export interface GridRowDetailsV1DTO {
  rowCode: CodeDTO;
  rowOptionText?: SurveyLocalizedTextDTO | null;
}

export class GridRowDetailsV1 {
  readonly isGridRowDetailsV1GridRowDetailsV1: boolean = true;

  readonly rowCode: Code;
  readonly rowOptionText: SurveyLocalizedText | null;


  constructor(
  rowCode: Code, 
  rowOptionText: SurveyLocalizedText | null = null
  ) {
    this.rowCode = rowCode;
    this.rowOptionText = rowOptionText;
  }

  static fromDTO(dto: GridRowDetailsV1DTO): GridRowDetailsV1 {
    const rowCode = Code.fromDTO(getObject(dto, "rowCode", InvalidGridRowDetailsV1RowCodeError));
    let rowOptionText = getOptionalObject(dto, "rowOptionText");
    if(rowOptionText !== undefined && rowOptionText !== null) {
      rowOptionText = SurveyLocalizedText.fromDTO(getObject(dto, "rowOptionText", InvalidGridRowDetailsV1RowOptionTextError));
    }
    return new GridRowDetailsV1(
      rowCode,
      rowOptionText
    );
  }

  toDTO(): GridRowDetailsV1DTO {
    const dto: GridRowDetailsV1DTO = {
        rowCode: this.rowCode.toDTO(),
    };
    if (this.rowOptionText !== undefined && this.rowOptionText !== null){
      dto.rowOptionText = this.rowOptionText.toDTO();
    }
    return dto;
  }
  }

GridRowDetailsV1.prototype.toString = function toString(): string {
  return `GridRowDetailsV1(rowCode='${this.rowCode}',rowOptionText='${this.rowOptionText}')`;
};

export class InvalidGridRowDetailsV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridRowDetailsV1Error";
  }
}
export class InvalidGridRowDetailsV1RowCodeError extends InvalidGridRowDetailsV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridRowDetailsV1RowCodeError";
  }
}

export class InvalidGridRowDetailsV1RowOptionTextError extends InvalidGridRowDetailsV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridRowDetailsV1RowOptionTextError";
  }
}
